import Vue from 'vue'
import App from './App.vue'
import MetaInfo from 'vue-meta-info'
import scroll from 'vue-seamless-scroll'

import { Popup, Picker, DatetimePicker, Uploader } from 'vant';
import 'vant/lib/index.css';

Vue.use(Popup);
Vue.use(Picker);
Vue.use(DatetimePicker);
Vue.use(Uploader)
Vue.use(MetaInfo)
Vue.use(scroll)


const eventNames=["点击_专题页_按钮","点击_专题页_课程"]
const btnNames= ["按钮名称","课程名称"]
Vue.prototype.mai=(pageName,btnName,isCourse,diffName)=>{
  zhuge.track(eventNames[isCourse],{
  专题页名称:pageName,
  终端:"H5",
  [btnNames[isCourse]]: btnName,
  ...(diffName ? {备注:diffName}:{})
  })
}
function getQuery(key){
   var url = window.location.search;
      var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
      var result = url.substr(1).match(reg);
      return result ? decodeURIComponent(result[2]) : null;
}
Vue.prototype.getQueryString=(key) =>{
     return getQuery(key)
    }
if(window.location.href.indexOf('localhost:3001') === -1) {
  require('./utils/zhuge')
}
Vue.prototype.clickZiXun=()=>{
  let from=getQuery("from")
  if(from=='introDetail'){
    window.parent.postMessage({ type: 'zixun' }, '*');
  }else{
     qimoChatClick();
  }
  
}
Vue.config.productionTip = false
for (const i in process.env) {
  const a = i.substr(13)
  window[a] = process.env[i]
}
new Vue({
  render: (h) => h(App),
  mounted: () => {
    document.dispatchEvent(new Event('custom-render-trigger'))
  }
}).$mount('#app')
